import React from 'react';
import { ArrowDown, Building2, Shield } from 'lucide-react';
import { useToast } from '../../../../../components/common/Toast';
import { useAccessTheme } from '../useAccessTheme';
import IdentityProviderModalShell from './IdentityProviderModalShell';
import { CapabilityCheckList } from './ProviderBadges';
import { DEMO_SETUP_MESSAGE } from './identityProviderTypes';

interface ActiveDirectorySetupModalProps {
  onClose: () => void;
}

const FLOW_STEPS = ['Active Directory', 'Directory Connector', 'Selfic'];

const ActiveDirectorySetupModal: React.FC<ActiveDirectorySetupModalProps> = ({ onClose }) => {
  const t = useAccessTheme();
  const { showToast } = useToast();

  return (
    <IdentityProviderModalShell
      title="Connect Active Directory"
      subtitle="Install a directory connector inside your network to synchronize Active Directory users and groups."
      icon={<Building2 className="w-5 h-5" />}
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={() => showToast({ type: 'info', message: DEMO_SETUP_MESSAGE })}
          className={'px-4 py-2 rounded-lg text-sm font-medium ' + t.btnPrimary}
        >
          Set Up Directory Connector
        </button>
      }
    >
      <div className="flex flex-col items-center gap-1.5 py-1">
        {FLOW_STEPS.map((label, index) => (
          <React.Fragment key={label}>
            <div className={`w-full max-w-xs rounded-lg border px-3 py-2 text-sm font-medium text-center ${t.tableShell} ${t.title}`}>
              {label}
            </div>
            {index < FLOW_STEPS.length - 1 ? <ArrowDown className={`w-4 h-4 ${t.muted}`} /> : null}
          </React.Fragment>
        ))}
      </div>

      <CapabilityCheckList items={['Users', 'Groups', 'Group memberships', 'Departments']} />

      <div className={`flex items-start gap-2 rounded-lg border px-3 py-2.5 ${t.border}`}>
        <Shield className={`w-4 h-4 mt-0.5 shrink-0 ${t.accentText}`} />
        <p className={`text-sm ${t.body}`}>
          The connector communicates with Selfic using outbound HTTPS. Your domain controller does not
          need to be publicly exposed.
        </p>
      </div>
    </IdentityProviderModalShell>
  );
};

export default ActiveDirectorySetupModal;
